import { render, staticRenderFns } from "./AtendimentoCard.vue?vue&type=template&id=517e0bda&scoped=true"
import script from "./AtendimentoCard.vue?vue&type=script&lang=js"
export * from "./AtendimentoCard.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoCard.vue?vue&type=style&index=0&id=517e0bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517e0bda",
  null
  
)

export default component.exports